import { io } from 'socket.io-client';
let socket;

export const initSocket = (uid, socketLink) => {
  if (!socket || !socket.connected) {  // چک می‌کنیم که آیا سوکت متصل است یا خیر
    socket = io(socketLink, {
      transports: ['websocket'],
      jsonp: false,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 2000,
    });

    socket.on('connect', () => {
      console.log('Connected to socket server');
      socket.emit('connected', { room: uid });
    });
  } else {
    console.log('Socket is already connected');
  }

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    console.log('Socket disconnected');
    socket.disconnect();
    socket = null;
  }
};
